const defaultCellRenderer = ({ cellData }) => {
  if (cellData == null) {
    return '';
  }

  return String(cellData);
};

export default defaultCellRenderer;
